export function BarChartIcon() {
  return (
    // eslint-disable-next-line github/a11y-svg-has-accessible-name
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <line x1="1.75" y1="0.75" x2="1.75" y2="15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <rect x="1" y="3" width="9" height="3" rx="1.5" fill="currentColor" />
        <rect x="1" y="7" width="13" height="3" rx="1.5" fill="currentColor" />
        <rect x="1" y="11" width="6" height="3" rx="1.5" fill="currentColor" />
      </g>
    </svg>
  )
}

try{ BarChartIcon.displayName ||= 'BarChartIcon' } catch {}